/**
 * Copyright (c) 2022 Yoshinobu Obata
 * Released under the Apache-2.0 license
 * LICENSE: http://www.apache.org/licenses/LICENSE-2.0
 */

/**
 * 拡張機能間で共有するモジュールを管理するシングルトン
 * window.kurikitSharedModules を使用してモジュールを共有
 */

const SHARED_NAMESPACE = 'kurikitSharedModules';

/**
 * 共有名前空間を初期化
 */
function initializeSharedNamespace() {
    if (!window[SHARED_NAMESPACE]) {
        window[SHARED_NAMESPACE] = {
            modules: {},
            transformersLoaded: false,
            transformersLoading: false
        };
    }
    return window[SHARED_NAMESPACE];
}

/**
 * 共有モジュールを取得
 * @param {string} moduleName - モジュール名
 * @returns {Object|null} モジュールインスタンス or null
 */
function getSharedModule(moduleName) {
    const shared = initializeSharedNamespace();
    return shared.modules[moduleName] || null;
}

/**
 * 共有モジュールを登録
 * @param {string} moduleName - モジュール名
 * @param {Object} moduleInstance - モジュールインスタンス
 */
function setSharedModule(moduleName, moduleInstance) {
    const shared = initializeSharedNamespace();
    shared.modules[moduleName] = moduleInstance;
}

/**
 * 共有モジュールが存在するか確認
 * @param {string} moduleName - モジュール名
 * @returns {boolean}
 */
function hasSharedModule(moduleName) {
    const shared = initializeSharedNamespace();
    return !!shared.modules[moduleName];
}

/**
 * Transformers.js がロード済みか確認
 * @returns {boolean}
 */
function isTransformersLoaded() {
    const shared = initializeSharedNamespace();
    return shared.transformersLoaded || !!window.transformers;
}

/**
 * Transformers.js がロード中か確認
 * @returns {boolean}
 */
function isTransformersLoading() {
    const shared = initializeSharedNamespace();
    return shared.transformersLoading;
}

/**
 * Transformers.js のロード状態を設定
 * @param {string} state - 'loading' | 'loaded'
 */
function setTransformersState(state) {
    const shared = initializeSharedNamespace();
    if (state === 'loading') {
        shared.transformersLoading = true;
    } else if (state === 'loaded') {
        shared.transformersLoaded = true;
        shared.transformersLoading = false;
    }
}

/**
 * Transformers.js のロード完了を待つ
 * @returns {Promise<void>}
 */
async function waitForTransformers() {
    return new Promise((resolve) => {
        const checkInterval = setInterval(() => {
            if (window.transformers) {
                clearInterval(checkInterval);
                resolve();
            }
        }, 100);
    });
}

module.exports = {
    SHARED_NAMESPACE,
    initializeSharedNamespace,
    getSharedModule,
    setSharedModule,
    hasSharedModule,
    isTransformersLoaded,
    isTransformersLoading,
    setTransformersState,
    waitForTransformers
};
